import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";
import {RadioQuestionPreviewComponent} from "./RadioQuestionPreviewComponent";

export class LikertScaleQuestionPreviewComponent extends RadioQuestionPreviewComponent {

    setup() {
        this.choices = [
            'strongly_disagree',
            'disagree',
            'in_between',
            'agree',
            'strongly_agree',
        ];

        super.setup();
    }

}

app.component('likertScaleQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/radioQuestionPreview.html',
    controller  : LikertScaleQuestionPreviewComponent,
    controllerAs: 'radioQuestionPreview',
    bindings    : {
        question: '<',
    }
});